import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { name: '首页', path: '/' },
    { name: '网红塌房', path: '/category/wanghong-tafang' },
    { name: '明星八卦', path: '/category/mingxing-bagua' },
    { name: '社会奇闻', path: '/category/shehui-qiwen' },
  ],
  独家内容: [
    { name: '独家黑料', path: '/category/dujia-heiliao' },
    { name: '实时追踪', path: '/' },
    { name: '投稿爆料', path: '/about' },
    { name: '热门排行', path: '/' },
  ],
  关于我们: [
    { name: '品牌介绍', path: '/about' },
    { name: '联系方式', path: '/about' },
    { name: '隐私政策', path: '/about' },
    { name: '用户协议', path: '/about' },
  ],
  友情链接: [
    { name: '热搜榜单', path: '/' },
    { name: '娱乐资讯', path: '/' },
    { name: '网红动态', path: '/' },
    { name: '爆料投稿', path: '/about' },
  ],
};

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-white">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-white text-lg"></i>
              </div>
              <span className="text-xl font-heading font-bold text-white whitespace-nowrap">
                911吃瓜网
              </span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed mb-6">
              第一时间追踪网红塌房、明星八卦、社会奇闻。
              <br />
              吃瓜群众的首选资讯平台。
            </p>
            <div className="flex items-center gap-3">
              {['ri-weibo-line', 'ri-wechat-line', 'ri-live-line', 'ri-bilibili-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center border border-foreground-600 rounded-lg text-foreground-300 hover:text-white hover:border-primary-500 transition-all duration-200 cursor-pointer"
                  rel="nofollow"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-white mb-4 whitespace-nowrap">
                {title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400 whitespace-nowrap">
            &copy; {currentYear} 911吃瓜网 All Rights Reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
              用户协议
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}